<template>
  <div class="flexChart">
    <div class="chartContent">
      <div class="content content-sans">Abweichung der Temperatur des Vormonats vom Langzeitmittel</div>
    </div>
    <div class="chartContainer" ref="chartContainer">
      <div ref="chart" class="lineChart"></div>
    </div>
  </div>
</template>

<script>
import { store } from "../store";
import * as d3 from "d3";
import _ from "lodash";

export default {
  data() {
    return {
      store,
    };
  },
  props: {
    dataTempDeviation: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleResize: _.debounce(function () {
      this.windowWidth = window.innerWidth;
      const chartParent = this.$refs.chart;
      const svgNode = chartParent.querySelector("svg");
      chartParent.removeChild(svgNode);
      this.drawChart(this.$refs.chartContainer.clientWidth);
    }, 200),
    drawChart(containerWidth) {
      const chartWidth = containerWidth;
      //console.log("drawChart TempDeviation", console.log(JSON.stringify(this.dataTempDeviation)));

      // const data = [
      //   ["Feb. 1961", 4],
      //   ["Feb. 1962", -0.2],
      //   ["Feb. 1963", -6.1],
      //   ["Feb. 1964", 0.2],
      // ];
      const data = this.dataTempDeviation;

      data.forEach(function (item) {
        item.push(7);
        item.push(-7);
      });

      //console.log("dataTempDeviation", data);

      const margin = { top: 20, right: 0, bottom: 30, left: 10 };
      const width = chartWidth - margin.left - margin.right;
      const height = 95 - margin.top - margin.bottom;

      const maxVal = d3.max(data, (d) => d[1]);
      const minVal = d3.min(data, (d) => d[1]);
      const absMax = Math.max(Math.abs(maxVal), Math.abs(minVal));
      const tickVals = [5, 0, -5]; // set tick values to fixed values

      // Set the width of the left axis
      const yAxisWidth = 10;

      const svg = d3
        .select(this.$refs.chart)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${margin.left}, ${margin.top})`);

      const xScale = d3
        .scaleBand()
        .domain(data.map((d) => d[0]))
        .range([0, width - yAxisWidth])
        .padding(0.1);

      const tooltip = d3
        .select(this.$refs.chartContainer)
        .append("div")
        .attr("class", "tooltip3 tooltip")
        .style("opacity", 0);

      const yScale = d3.scaleLinear().domain([-absMax, absMax]).range([height, 0]);

      const y = d3.scaleLinear().domain([-absMax, absMax]).range([height, 0]).nice();

      const x = d3
        .scaleBand()
        .domain(data.map((d) => d))
        .range([0, width - yAxisWidth])
        .padding(0.4);
      const xAxis = d3.axisBottom(x);

      xAxis
        .tickValues([data[0][0], data[data.length - 1]])
        .tickSize(0)
        .tickSizeInner(0);

      const yAxis = d3
        .axisLeft(yScale)
        .tickValues(tickVals)
        .tickSizeInner(-width)
        .tickFormat((d) => (d === 5 ? "+" + d : d)); // add " Grad" to tick value 5

      svg
        .append("g")
        .attr("transform", `translate(${margin.left}, ${height + 2})`)
        .attr("width", `${width})`)
        .classed("axis-label", true);
      svg
        .append("text")
        .attr("class", "axis-label")
        .attr("x", 10)
        .attr("y", height + margin.bottom - 4)
        .attr("text-anchor", "start")
        .attr("fill", "var(--mm-grey-400)")
        .text(data[0][0]);
      svg
        .append("text")
        .attr("class", "axis-label")
        .attr("x", width)
        .attr("y", height + margin.bottom - 4)
        .attr("text-anchor", "end")
        .attr("fill", "var(--mm-grey-400)")
        .text(data[data.length - 1][0]);

      svg
        .append("g")
        .attr("width", "25px")
        .attr("class", "y axis")
        .attr("transform", "translate(" + yAxisWidth + ", 0)")
        .call(yAxis)
        .classed("axis-label", true);

      const bar = svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("x", (d) => xScale(d[0]))
        .attr("width", xScale.bandwidth())
        //.attr("y", (d) => height / 2)
        //.attr("height", (d) => 0)
        .attr("y", (d) => yScale(Math.max(0, d[1])))
        .attr("height", (d) => Math.abs(yScale(d[1]) - yScale(0)))
        .attr("fill", (d) => (d[1] < 0 ? "var(--mm-red-color4)" : "var(--mm-red-color3)"))
        .attr("transform", "translate(" + yAxisWidth + ", 0)");
      // .on("mouseenter", (event, d) => {
      //   const containerOffset = bar.node().getBoundingClientRect();
      //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      //   let plus = "";
      //   if (d[1] > 0) {
      //     plus = "+";
      //   }
      //   tooltip.transition().duration(200).style("opacity", 0.9);
      //   tooltip
      //     .html(d[0].toString() + "</br><b>" + plus + d[1].toString().replace(".", ",") + "\u2009°C</b>")
      //     .style("left", event.pageX - containerOffset.left + "px")
      //     .style("top", height / 2 + 10 + "px")
      //     .style("pointer-events", "none")
      //     .style("cursor", "pointer");
      // })
      // .on("mouseleave", (event, d) => {
      //   tooltip.transition().duration(500).style("opacity", 0);
      // });

      const bar2 = svg
        .selectAll(".bar2")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar2, mask")
        .attr("x", (d) => xScale(d[0]))
        .attr("width", xScale.bandwidth() + 1)
        //.attr("y", (d) => height / 2)
        //.attr("height", (d) => 0)
        .attr("y", (d) => yScale(Math.max(0, d[2])))
        .attr("height", (d) => height * 2)
        .attr("fill", "transparent")
        .attr("transform", "translate(" + yAxisWidth + ", 0)")
        .style("cursor", "pointer")
        .on("mouseover", () => {})
        .on("touchmove mousemove", (event, d) => {
          const containerOffset = bar.node().getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          let plus = "";
          if (d[1] > 0) {
            plus = "+";
          }
          tooltip.transition().duration(200).style("opacity", 0.9);
          tooltip
            .html(d[0].toString() + "</br><b>" + plus + d[1].toString().replace(".", ",") + "\u2009°C</b>")
            .style("left", event.pageX - containerOffset.left + 20 + "px")
            .style("top", height / 2 + 10 + "px")
            .style("pointer-events", "none")
            .style("cursor", "pointer");
        })
        .on("mouseout", (event, d) => {
          tooltip.transition().duration(500).style("opacity", 0);
        });

      // .style("pointer-events", "all")
      // .style("cursor", "pointer")
      // .on("mouseover", () => {})
      // .on("mouseout", () => {
      //   tooltip.style("opacity", 0);
      //   verticalLine.attr("opacity", 0);
      //   circleLine1.attr("opacity", 0);
      //   circleLine2.attr("opacity", 0);
      // })
      // .on("touchmove mousemove", mouseMove);

      // .transition() // remove animation
      // .delay((d, i) => 180 + i * 10)
      // .duration(500)
      // .attr("y", (d) => yScale(Math.max(0, d[1])))
      // .attr("height", (d) => Math.abs(yScale(d[1]) - yScale(0)));
    },
  },
  watch: {
    dataTempDeviation() {
      let chartWidth = this.$refs.chartContainer.clientWidth;
      this.drawChart(chartWidth);
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
